import { useSWR } from 'modules/network/hooks/useSwr'
import { PoolAsset } from 'modules/pools/constants/poolAssets'
import { getAssetPairPrice } from '../utils/getAssetPairPrice'
import { useWeb3 } from './useWeb3'

type Asset = PoolAsset | '' | null | undefined

// Calculates assetA/assetB pair current rate
export const useAssetPairPrice = (
  assetA: Asset,
  assetB: Asset | 'USD',
  assetAAmount?: number,
) => {
  const { chainId } = useWeb3()

  const { data: priceData } = useSWR(
    `${assetA}-${assetB}-${chainId}-price`,
    async () => {
      if (!assetA || !assetB) return

      const res = await getAssetPairPrice({
        assetA,
        assetB,
        assetAAmount,
        chainId,
      })

      return res
    },
  )

  return priceData
}
